import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello! I’m <span className="purple">Jeff Akin</span> from{" "}
            <span className="purple">Richmond, Texas (USA)</span>.
            <br />
            I’m a <span className="purple">Senior Data Engineer</span> with
            9+ years of experience across healthcare, finance, and manufacturing.
            <br />
            I specialize in building scalable <span className="purple">
            cloud data platforms</span> and end-to-end ETL/ELT pipelines using
            Airflow, dbt, Spark, Kafka, and Snowflake on AWS, Azure, and GCP.
            <br />
            <br />
            Outside of data work, I like to stay creative through:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Contributing to open-source data tools ⚙️
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing tech articles on data architecture ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring analytics in real-world domains 🌎
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            “Turn data into insight and insight into action.”
          </p>
          <footer className="blockquote-footer">Jeff Akin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
